import React from "react";
import Dashboard from "./views/Dashboard";
import PrivacyPolicy from "./components/PrivacyPolicy";

export default function MyAccount() {
  return <PrivacyPolicy />;
}
